// removed by extract-text-webpack-plugin
module.exports = {"flatCard":"_3YybM5i8","header":"_3-KTWU2U"};


//////////////////
// WEBPACK FOOTER
// ./app/orders/containers/orders/orders.styles.scss
// module id = 714
// module chunks = 0